/**
 * Returns the file extension (in lowercase) from a given filename or path.
 *
 * Asset records reach the UI with `filename` / `videotype` missing, so a
 * non-string returns '' rather than throwing and taking the render down.
 *
 * @param {string} file - The filename or path to extract the extension from.
 * @returns {string} The lowercase file extension, or '' if there is no filename.
 */
export const getExtention = (file) => (typeof file === 'string' ? file.split('.').pop().toLowerCase() : '');
